import { DateTimeUtc } from '@mews/framework/datetime';
import { createAction } from '@mews/framework/redux';
import {
    CLEAR_TIMES,
    DATES_SET,
    END_DATE_SET,
    END_TIME_UTC_SET,
    START_DATE_SET,
    START_TIME_UTC_SET,
} from '../modules/resourceOrder/actionTypes';

export const setStartDate = (date: string) => createAction(START_DATE_SET, { startDate: date });

export const setEndDate = (date: string) => createAction(END_DATE_SET, { endDate: date });

export const setDates = (startDate: string | null, endDate: string | null) =>
    createAction(DATES_SET, { startDate, endDate });

export const setStartTimeUtc = (dateUtc: DateTimeUtc | null, timezone: string) =>
    createAction(START_TIME_UTC_SET, { startTimeUtc: dateUtc, timezone });

export const setEndTimeUtc = (dateUtc: DateTimeUtc | null, timezone: string) =>
    createAction(END_TIME_UTC_SET, { endTimeUtc: dateUtc, timezone });

export const clearTimes = () => createAction(CLEAR_TIMES);
